import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL_UPDATED } from "@/lib/legal";

const Section = ({ s }) => (
  <section className="mb-10">
    <h3 className="font-serif text-2xl text-[#D4AF37] mb-4">{s.title}</h3>
    {s.body?.map((p) => <p key={p} className="text-[#C9C0B4] leading-relaxed mb-3">{p}</p>)}
    {s.list && (
      <ul className="list-disc pl-5 space-y-2 text-[#C9C0B4] leading-relaxed">
        {s.list.map((p) => <li key={p}>{p}</li>)}
      </ul>
    )}
    {s.table && (
      <div className="overflow-x-auto rounded-lg border border-[#2E252A] mt-4">
        <table className="w-full text-sm">
          <thead className="bg-[#110D0F] text-left font-mono text-[10px] uppercase tracking-[0.2em] text-[#6E665D]">
            <tr><th className="px-4 py-3 font-normal">Nome</th><th className="px-4 py-3 font-normal">Finalidade</th><th className="px-4 py-3 font-normal">Tipo</th><th className="px-4 py-3 font-normal">Duração</th></tr>
          </thead>
          <tbody>
            {s.table.map((r) => (
              <tr key={r[0]} className="border-t border-[#2E252A]">
                <td className="px-4 py-3 font-mono text-[#F5F0EB] whitespace-nowrap">{r[0]}</td>
                <td className="px-4 py-3 text-[#C9C0B4]">{r[1]}</td>
                <td className="px-4 py-3 text-[#A89F91]">{r[2]}</td>
                <td className="px-4 py-3 text-[#A89F91] whitespace-nowrap">{r[3]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </section>
);

export const LegalLinks = ({ className = "" }) => (
  <div className={`flex flex-wrap gap-x-4 gap-y-1 text-xs text-[#6E665D] ${className}`}>
    <Link to="/privacy" className="hover:text-[#D4AF37]" data-testid="privacy-policy-link">Política de Privacidade</Link>
    <Link to="/cookies" className="hover:text-[#D4AF37]" data-testid="cookie-policy-link">Política de Cookies</Link>
  </div>
);

export const LegalPage = ({ title, sections, testId }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0D0A0B]" data-testid={testId}>
      <div className="max-w-3xl mx-auto px-6 py-10 sm:py-16">
        <button onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/"))} className="flex items-center gap-2 text-sm text-[#A89F91] hover:text-[#D4AF37] mb-10" data-testid="legal-back-button">
          <ArrowLeft className="w-4 h-4" /> Voltar
        </button>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-3">The Cellar Book</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#F5F0EB] mb-3">{title}</h1>
        <p className="text-sm text-[#6E665D] mb-12">Última atualização: {LEGAL_UPDATED}</p>
        {sections.map((s) => <Section key={s.title} s={s} />)}
        <LegalLinks className="pt-8 border-t border-[#2E252A]" />
      </div>
    </div>
  );
};
